import { Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Crane: React.FC<Props> = ({ fill }) => {
    return (
        <Svg fill={fill} viewBox="0 0 512 512" width={"12pt"} height={"100%"}>
            <Path d="M413.711,100.117l-32-80C376.852,7.969,365.086,0,352,0H160c-13.086,0-24.852,7.969-29.711,20.117l-32,80  c-3.055,7.625-3.055,16.141,0,23.766l32,80C135.148,216.031,146.914,224,160,224h16c0,17.672,14.328,32,32,32h16v12.289  c0,38.055,20.82,72.805,53.031,88.539C293.664,364.961,304,381.5,304,399.992c0,25.57-22.438,48.008-48.008,48.008  C229.531,448,208,426.469,208,400c0-17.672-14.328-32-32-32s-32,14.328-32,32c0,61.758,50.242,112,111.992,112  C316.703,512,368,460.703,368,399.992c0-43.141-24.094-81.711-62.875-100.664C294.719,294.242,288,282.063,288,268.289V256h16  c17.672,0,32-14.328,32-32h16c13.086,0,24.852-7.969,29.711-20.117l32-80C416.766,116.258,416.766,107.742,413.711,100.117z   M181.334,176H147.6l42.666-128H224L181.334,176z M251.534,176H217.8l42.666-128H294.2L251.534,176z M321.734,176H288l42.666-128  H364.4L321.734,176z" />
        </Svg>
    );
};

export default Crane;
